import React, { Component } from 'react'
import { Button, Heading, Modal } from '@/components'
import FeedbackForm from '@/components/FeedbackForm/FeedbackForm'
import { inject, observer } from 'mobx-react'

@inject('contentStore', 'uiStore')
@observer
export default class FeedbackModal extends Component {
  state = {
    feedback: null,
    isSubmitError: false,
    isSubmitting: false,
    selectedFeedbackType: null,
  }
  onClose = () => {
    const { onClose } = this.props
    this.setState({
      feedback: null,
      isSubmitError: false,
      isSubmitting: false,
      selectedFeedbackType: null,
    })
    if (onClose) {
      onClose()
    }
  }
  onSubmit = () => {
    const {
      activityId,
      contentStore,
      isExam,
      isOralExam,
      isQuiz,
      feedbackType: propFeedbackType,
    } = this.props
    const { feedback, selectedFeedbackType } = this.state

    this.setState({ isSubmitting: true })
    contentStore
      .sendActivityFeedback(activityId, {
        feedback: feedback,
        feedbackType: selectedFeedbackType || propFeedbackType,
        isExam: isExam || false,
        isOralExam: isOralExam || false,
        isQuiz: isQuiz || false,
      })
      .then((result) => {
        if (result instanceof Error) {
          this.setState({ isSubmitError: true, isSubmitting: false })
        } else {
          this.onClose()
        }
      })
  }
  onChangeFeedback = (value) => {
    this.setState({ feedback: value, isSubmitError: false })
  }
  onChangeFeedbackType = (type) => {
    this.setState({ selectedFeedbackType: type, isSubmitError: false })
  }
  render() {
    const { additionalFeedbackMessage, feedbackType, isOpen, isMobile, label } =
      this.props
    const { isSubmitError, isSubmitting, selectedFeedbackType } = this.state

    return (
      <Modal
        className="FeedbackModal"
        contentLabel="Feedback Modal"
        isOpen={isOpen}
        onClose={this.onClose}
      >
        <Modal.Header>
          <Heading>{label}</Heading>
        </Modal.Header>
        <Modal.Body>
          <FeedbackForm
            additionalFeedbackMessage={additionalFeedbackMessage}
            feedbackType={feedbackType}
            hideSubmitButton
            isMobile={isMobile}
            onChangeFeedback={this.onChangeFeedback}
            onChangeFeedbackType={this.onChangeFeedbackType}
          />
        </Modal.Body>
        <Modal.Footer>
          {isSubmitError ? (
            <span className="FeedbackForm__status-message FeedbackForm__status-message--error">
              * Failed to submit feedback
            </span>
          ) : null}
          <Button
            isDisabled={!selectedFeedbackType && !feedbackType}
            isLoading={isSubmitting}
            onClick={this.onSubmit}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
